// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uVlLQ","footer":"styles_footer__fCHvA"};